import React, {useEffect, useState} from 'react'
import RenderFields from "../../../common/ui/render-fields";
import {handleFieldValueChanges, prepareInputFields} from "../../../common/utils/field-change-util";
import _ from "lodash";
import {
    PRINTFUL_PRODUCTS_PRICE_FILTER_FIELDS,
} from "../../constants/printful-products-price.constant";

const emptyFilterCriteria: any = {
    product_type: '',
    category: '',
    sync: '',
};
let allFilterFields = _.groupBy(PRINTFUL_PRODUCTS_PRICE_FILTER_FIELDS, 'group')['filter'];
// allFilterFields = _.concat(allFilterFields, _.groupBy(PRINTFUL_PRODUCTS_PRICE_FILTER_FIELDS, 'group')['pagination']);
// const defaultSelectedField = {name: 'printfulProductsPriceType', value: 'module'};

const PrintfulProductsPriceFilters = ({filterCriteria, setFilterCriteria, printfulProductsPricesList}) => {
    const [initialStep, setInitialStep] = useState(true);
    const [printfulProductsPriceFilterFields, setPrintfulProductsPriceFilterFields] = useState(allFilterFields);
    const [productTypeCategoriesMap, setProductTypeCategoriesMap] = useState({});

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            prepareFilterFields();
        }
    }, [initialStep]);

    const prepareFilterFields = () => {
        const productsByTypeMap = _.groupBy(printfulProductsPricesList, 'product_type');
        const productTypes = _.compact(_.keys(productsByTypeMap));
        const existingProductTypeCategoriesMap = {...productTypeCategoriesMap};

        let productTypesList = _.map(productTypes, (productType) => {
            if (!_.isEmpty(productType) && productType !== "undefined") {
                const productTypeProducts = productsByTypeMap[productType];
                const productTypeCategories = _.uniq(_.map(productTypeProducts, 'category'));

                existingProductTypeCategoriesMap[productType] = _.map(productTypeCategories, (category) => {
                    return {key: category, label: category};
                });

                return {key: productType, label: productType};
            }
        });

        productTypesList = _.compact(productTypesList);
        setProductTypeCategoriesMap(existingProductTypeCategoriesMap);

        const exitingFilterFields = [...printfulProductsPriceFilterFields];

        _.forEach(exitingFilterFields, (filterField) => {
            if (filterField.attribute === 'product_type') {
                filterField.options = _.orderBy(productTypesList, ['label'], ['asc']);
            }
        });

        setPrintfulProductsPriceFilterFields(exitingFilterFields);
    }

    const handleFilterChanges = (event) => {
        const existingFilterCriteria = {...filterCriteria};

        const {name} = event.target;
        if (name === 'product_type') {
            const exitingFilterFields = [...printfulProductsPriceFilterFields];
            const existingProductTypeCategoriesMap = {...productTypeCategoriesMap};

            _.forEach(exitingFilterFields, (filterField) => {
                if (filterField.attribute === 'category') {
                    const categories = existingProductTypeCategoriesMap[event.target.value] || [];
                    filterField.options = _.orderBy(categories, ['label'], ['asc']);
                    delete existingFilterCriteria[filterField.attribute];
                }
            });

            setPrintfulProductsPriceFilterFields(exitingFilterFields);
        }

        handleFieldValueChanges(event, existingFilterCriteria, setFilterCriteria);
    }

    const clearFilterCriteria = () => {
        setFilterCriteria(emptyFilterCriteria);
    }

    return (
        <>
            <div className="flex flex-wrap justify-start w-1/2">
                <RenderFields
                    parentForm={filterCriteria}
                    handleDetailChanges={handleFilterChanges}
                    fieldList={printfulProductsPriceFilterFields}
                    enableEdit={true}
                    fieldClassName={`w-1/${(printfulProductsPriceFilterFields?.length) || (allFilterFields.length)}`}/>
            </div>

            <div className="w-40">
                <button
                    onClick={() => clearFilterCriteria()}
                    className="button-link mt-7">
                    Clear Filters
                </button>
            </div>
        </>
    )
}

export default PrintfulProductsPriceFilters
